module.exports = "<p>\n  requirements works!\n</p>\n"